<template>
  <div class="wrapper">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img v-on:click="back()" :src="icon" class="icon" />
      <p class="title">
        {{ this.$store.getters.TRANSLATIONS["reset_password"] }}
      </p>
    </div>
    <div class="content" v-if="!loading">
      <p class="content_title">
        {{ this.$store.getters.TRANSLATIONS["reset_your_password"] }}
      </p>
      <input
        type="text"
        v-model="email"
        :placeholder="this.$store.getters.TRANSLATIONS['email']"
        class="email"
        autocomplete="off"
      />
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="doReset()" class="button">
        {{ this.$store.getters.TRANSLATIONS["next"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%" :width="350" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      email: "",
      doReset: () => {
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.$http
          .post(`${process.env.SERVER_URL}/717F890DFE854A3FBC35FA001798FAFD`, {
            email: this.email
          })
          .then((response) => {
            this.$modal.show("dialog", {
              text: this.$store.getters.TRANSLATIONS["if_your_email_exists"],
              buttons: [
                {
                  title: "OK",
                  handler: () => {
                    this.$store.dispatch(
                      "SAVE_RESET_PASS_CODE",
                      response.data.code
                    );
                    this.$router.push("/forgotPasswordCode");
                  }
                }
              ]
            });
          })
          .catch(() => {
            this.$modal.show("dialog", {
              text: this.$store.getters.TRANSLATIONS["if_your_email_exists"],
              buttons: [
                {
                  title: "OK",
                  handler: () => {
                    this.$router.push("/forgotPasswordCode");
                  }
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      },
      back: () => {
        this.$router.push("/login");
      },
      icon: require("@/assets/icon_back.png")
    };
  }
};
</script>

<style scoped src="../styles/main.css"></style>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue